module.exports = __webpack_public_path__ + "static/media/kite_surfing_640.7109507d.webp";